// Home page translations - English
export const homeEn = {
  // Welcome/hero section
  welcome: {
    title: 'Find your next vehicle at',
    description:
      'Describe your dream vehicle and let our AI find the best options for you.',
    searchButton: 'Search vehicles',
    aiSearchPlaceholder: 'Search by brand, model, type, color, condition...',
    clearSearch: 'Clear',
    search: 'Search',
    voiceSearch: 'Voice search',
  },

  // Why choose us section
  whyUs: {
    title: 'Why choose us?',
    subtitle: 'Discover why our customers trust us',
    defaultFeatures: {
      quality: {
        title: 'Quality Vehicles',
        description: 'All our vehicles undergo rigorous quality inspection.',
      },
      experience: {
        title: 'Years of Experience',
        description:
          'We have over 10 years of experience in the automotive market.',
      },
      service: {
        title: 'Personalized Service',
        description:
          'We accompany you throughout the entire vehicle purchase process.',
      },
    },
  },

  // Contact CTA section
  contactCTA: {
    title: 'Ready to find your next vehicle?',
    subtitle: 'Contact us today.',
    button: 'Contact',
    phone: 'Call now',
    whatsapp: 'WhatsApp',
  },

  // How to arrive section
  howToArrive: {
    title: 'How to get here?',
    subtitle: 'Find us at the following address:',
    button: 'Get directions on Google Maps',
    address: 'Address',
    hours: 'Business hours',
    phone: 'Phone',
    email: 'Email',
    ofTotal: 'of',
    showMap: 'View map',
    mapUnavailable: "We couldn't load the map.",
  },

  // Featured vehicles section
  featuredVehicles: {
    title: 'Featured Vehicles',
    subtitle: 'Discover our selection of premium vehicles',
    viewAll: 'View all vehicles',
    noVehicles: 'No featured vehicles available',
  },
};



